import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Ban, CreditCard, Loader2 } from "lucide-react";

// Shown to a cleaner who owes My Clean Connect™ money: they cannot accept new bookings.
export default function RestrictedBanner() {
  const [state, setState] = useState(null);
  const [paying, setPaying] = useState(false);
  useEffect(() => { api.get("/noshow/fees/mine").then((r) => setState(r.data)).catch(() => {}); }, []);

  const payNow = async () => {
    setPaying(true);
    try {
      const { data } = await api.post("/payments/fee-checkout", { origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
      setPaying(false);
    }
  };

  if (!state?.restricted && !(state?.outstanding_balance > 0)) return null;
  const outstanding = state.fees?.filter((f) => f.status === "outstanding") || [];
  return (
    <div className="rounded-2xl border-2 border-red-300 bg-red-50 p-5" data-testid="restricted-account-banner">
      <div className="flex items-center gap-2">
        <Ban className="h-5 w-5 text-red-600" />
        <h3 className="font-display font-semibold text-red-800">Your account is restricted</h3>
      </div>
      <p className="text-sm text-red-900 mt-2">
        You owe My Clean Connect™ <strong>£{(state.outstanding_balance || 0).toFixed(2)}</strong>.
        You can't accept new bookings until this is cleared. Existing confirmed jobs are unaffected.
      </p>
      {outstanding.length > 0 && (
        <ul className="mt-3 space-y-1 text-sm text-red-900" data-testid="outstanding-fees">
          {outstanding.map((f) => (
            <li key={f.fee_id}>
              £{f.amount.toFixed(2)} — {f.type === "no_show" ? "confirmed no-show fee" : f.type}
              <span className="text-red-700"> · {new Date(f.created_at).toLocaleDateString("en-GB")}</span>
            </li>
          ))}
        </ul>
      )}
      <button onClick={payNow} disabled={paying}
        className="mt-4 w-full sm:w-auto px-6 py-3 rounded-full bg-red-600 text-white font-semibold hover:bg-red-700 transition-colors inline-flex items-center justify-center gap-2 disabled:opacity-50"
        data-testid="pay-outstanding-fee-btn">
        {paying ? <Loader2 className="h-4 w-4 animate-spin" /> : <CreditCard className="h-4 w-4" />}
        Pay £{(state.outstanding_balance || 0).toFixed(2)} now
      </button>
      <p className="text-xs text-red-800 mt-3">
        Pay securely by card and the restriction is lifted straight away. Prefer to talk to us? Email{" "}
        <strong>mycleanconnect@gmail.com</strong>. We never take money from your bank account automatically.
      </p>
    </div>
  );
}
